import _ from "lodash"

import { ChargeId } from "shared/hubrise/ids"
import * as Charge from "shared/hubrise/utils/Charge"

import { ICharge } from "../models"

import type { Change, OperationContext } from "./types"

export type ChargeOperations = {
  add(insertAfter: ICharge | undefined, values: Partial<ICharge>): ICharge
  delete(id: ChargeId): void
  move(charge: ICharge, newPosition: number): void
  update<T extends keyof ICharge>(id: ChargeId, fieldName: T, value: ICharge[T], options?: { collapse?: boolean }): void
}

export default ({ catalog, pushState }: OperationContext): ChargeOperations => ({
  add(insertAfter, values) {
    const { newCatalog, charge } = Charge.add(catalog, insertAfter, values)
    pushState(newCatalog, { model: "charge", operation: "add" })
    return charge
  },

  delete(id) {
    const newCatalog = Charge.doDelete(catalog, id)
    pushState(newCatalog, { model: "charge", operation: "delete", id })
  },

  move(charge, newPosition) {
    const newCatalog = Charge.move(catalog, charge, newPosition)
    const change: Change = { model: "charge", operation: "move", id: charge.id }
    pushState(newCatalog, change, (previousChange) => _.isEqual(previousChange, change))
  },

  update(id, fieldName, value, { collapse = true } = {}) {
    const newCatalog = Charge.update(catalog, id, fieldName, value)
    const change: Change = {
      model: "charge",
      id,
      operation: "update",
      fieldName,
    }
    pushState(newCatalog, change, (previousChange) => collapse && _.isEqual(previousChange, change))
  },
})
